const knownContexts = Object.freeze({
  energy: 'energy'
})

const defaultContexts = [
  {
    name: 'energy',
    path: ''
  }
]

function getAvailableContexts (tenantConfig) {
  return tenantConfig?.contexts || defaultContexts
}

function hasContext (name, tenantConfig) {
  return !!(this.getContextInfo(name, tenantConfig))
}

function getContextInfo (name, brandConfig) {
  return this.getAvailableContexts(brandConfig).find(ctx => ctx.name === name)
}

export { knownContexts }

export default { getAvailableContexts, hasContext, getContextInfo }
